import { Component, Input, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

    @Input() label;
    @Input() info;
    @Input() transparent = false;
    @Input() sizeSmall = false;

    constructor() {
    }

    ngOnInit() {
        if (this.info) {
            this.label = null;
        } else if (!this.label) {
            this.label = 'Загрузка...';
        }
    }
}
